import React from 'react';
import indexOf from 'lodash/indexOf';
import NumberUtils from '../../../../utils/NumberUtils';
import ProjectionStore from '../../../../stores/ProjectionStore';

const monthName = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * @todo
 * The quality of this component is poor.
 * Future work should be done to improve the situation.
 */
function DateConversion({ value }) {
  if (value !== '') {
    const fullDate = new Date(value);
    const day = fullDate.getDate();
    const month = fullDate.getMonth();
    const year = fullDate.getFullYear();
    return (
      <h5>{`${`0${day}`.slice(-2)} ${monthName[month].substring(0, 3)} ${year
        .toString()
        .substring(2, 4)}`}</h5>
    );
  } else {
    return null;
  }
}

/**
 * @todo
 * The quality of this component is poor.
 * Future work should be done to improve the situation.
 */
function ProjectionMobileEarnings({ data, getEarningsId }) {
  return (
    <div className="projection-earnings">
      {data.earnings &&
        data.earnings.length &&
        data.earnings.map((row, index) => (
          <div
            className={
              indexOf(ProjectionStore.getEarningId(), row.earningsId) >= 0
                ? 'earnings-active'
                : ''
            }
            onClick={() =>
              getEarningsId(row.earningsId, row.earningsEnabledFlag)
            }
            key={`ProjectionMobileEarnings_getContent_earnings_${index}`}
          >
            <div className="earnings-row">
              <section>
                <span>
                  <DateConversion value={row.earningsLastKnownDate} />
                </span>
                <p>{row.earningsName}</p>
              </section>
              <section>
                <h5>
                  {NumberUtils.appendCurrency(
                    '{}',
                    row.earningsLastKnownAmount
                  )}
                </h5>
                <p>{row.earningsFrequency}</p>
              </section>
            </div>
          </div>
        ))}
    </div>
  );
}

export { ProjectionMobileEarnings };
